import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-status-cards',
  templateUrl: './status-cards.component.html',
  styleUrls: ['./status-cards.component.scss']
})

export class StatusCardsComponent implements OnChanges {
  @Input() booking: any;

  public bookingStatus: any[] = [];
  public tooltipOpen = false;
  statusTypes: any;

  initStatus(){
    this.statusTypes = [
    {
      refKey: 'managerStatus',
      status: {
        PENDING: {
          color: 'blue',
          descriptor: 'Manager approval pending',
          denoter: 'assets/Manager_Approval_Pending.svg',
          },
          APPROVED: {
            color: 'green',
            descriptor: 'Manager approved',
          denoter: 'assets/Manager_Approval_Successful.svg',
        },
        REJECTED: {
          color: 'red',
          descriptor: 'Manager rejected',
          denoter: 'assets/Manager_Approval_Rejected.svg',

        },
        EXPIRED: {
          color: 'grey',
          descriptor: 'Approval expired',
          denoter: 'assets/Manager_Approval_Expired.svg'
        },
        ESCALATED: {
          color: 'orange',
          descriptor: 'Approval escalated',
          denoter: 'assets/Status.svg'
        }
      }
    },
    {
      refKey: 'vendorStatus',

      status: {
        PENDING: {
          color: 'blue',
          descriptor: 'Vendor acceptance pending',
          denoter: 'assets/Vendor_Approval_Pending.svg',
        },
        ACCEPTED: {
          color: 'green',
          descriptor: 'Vendor accepted',
          denoter: 'assets/Vendor_Approval_Successful.svg',
        },
        DENIED: {
          color: 'red',
          descriptor: 'Vendor denied',
          denoter: 'assets/Vendor_Approval_Rejected.svg',

        },
        EXPIRED: {
          color: 'grey',
          descriptor: 'Trip expired',
          denoter: 'assets/Vendor_Approval_Expired.svg',

        }
      }
    },
    {
      refKey: 'cabAllocStatus',
      status: {
        NOT_ALLOCATED: {
          color: 'blue',
          descriptor: 'Cab allocation pending',
          denoter: 'assets/Cab_Assignment_Pending.svg',

        },
        ALLOCATED: {
          color: 'orange',
          descriptor: 'Cab allocated',
          denoter: 'assets/Cab_Assignment_Pending.svg',

        },
        FINALIZED: {
          color: 'green',
          descriptor: 'Cab finalized',
          denoter: 'assets/Cab_Assignment_Successful.svg',

        },
        EXPIRED: {
          color: 'grey',
          descriptor: 'Trip expired',
          denoter: 'assets/Trip_Completion_Expired.svg'

        }
      }
    },
    {
      refKey: 'tripStatus',
      status: {
        UPCOMING: {
          color: 'blue',
          descriptor: 'Trip upcoming',
          denoter: 'assets/Trip_Upcoming.svg',
        },
        TRIP_EXPIRED: {
          color: 'grey',
          descriptor: 'Trip Expired',
          denoter: 'assets/Trip_Completion_Expired.svg',
        },
        MANUALLY_COMPLETED: {
          color: 'green',
          descriptor: 'Trip manually completed',
          denoter: 'assets/Trip_Completion_Successful.svg',
        },
        ON_TRIP: {
          color: 'blue',
          descriptor: this.getPickedCount(),
          denoter: 'assets/Ongoing.svg',
        },
        ON_DUTY: {
          color: 'blue',
          descriptor: 'On duty',
          denoter: 'assets/Trip_Completion_Pending.svg',
        },
        TRIP_COMPLETED: {
          color: 'green',
          descriptor: this.getNoShowcount(),
          denoter: 'assets/Trip_Completion_Successful.svg',
        },
        DUTY_COMPLETED: {
          color: 'green',
          descriptor: 'Duty completed',
          denoter: 'assets/Trip_Completion_Successful.svg',
        },
        TRIP_NO_SHOW: {
          color: 'red',
          descriptor: 'Trip no-show',
          denoter: 'assets/Trip_Completion_Rejected.svg',
        }
      }
    },
    {
      refKey: 'tripBillingStatus',
      status: {
        ACTIVE: {
          color: 'blue',
          descriptor: 'Billing active',
          denoter: 'assets/Billing_Pending.svg',

        },
        FROZEN: {
          color: 'orange',
          descriptor: 'Billing frozen',
          denoter: 'assets/Billing_Rejected.svg',
        },
        COMPLETED: {
          color: 'green',
          descriptor: 'Billing completed',
          denoter: 'assets/Billing_Successful.svg',
        },
        CLOSED: {
          color: 'green',
          descriptor: 'Billing closed',
          denoter: 'assets/Billing_Successful.svg',
        }
      }
    }, {
      refKey: 'paymentStatus',
      status: {
        PENDING: {
          color: 'blue',
          descriptor: 'Payment pending',
          denoter: 'assets/Payment_Pending.svg',
        },
        PAID: {
          color: 'green',
          descriptor: 'Paid',
          denoter: 'assets/Payment_Successful.svg',
        },
        PROCESSING: {
          color: 'orange',
          descriptor: 'Payment processing',
          denoter: 'assets/Payment_Pending.svg',
        },
        FAILED: {
          color: 'red',
          descriptor: 'Payment failed',
          denoter: 'assets/Payment_Rejected.svg',
        }
      }
    }];
    }

  getNoShowcount() {
    const noshow = this.booking.stops.reduce((count, stop) => {
      return count + stop.riders.filter(rider => rider.boardingType === 'PickUp' && rider.noShow).length;
    }, 0);
    return `Trip Completed (${noshow} No Show)`;
  }

  getPickedCount(){
  const counts = this.booking.stops.reduce(
    (result, stop) => {
      stop.riders.forEach((rider) => {
        if (rider.boardingType === 'PickUp') {
          result.totalRiders++;
        }
        if (rider.boardingType === 'PickUp' && (rider.boardingStatus === 'PICKED' || rider.boardingStatus === 'DROPPED')) {
          result.pickedRiders++;
        }
      });
      return result;
    },
    { totalRiders: 0, pickedRiders: 0 }
  );

  return `Trip Ongoing (${counts.pickedRiders}/${counts.totalRiders} Picked)`;
  }

  ngOnChanges(changes) {
    this.initStatus();
    if (JSON.stringify(changes.booking.currentValue) === JSON.stringify(changes.booking.previousValue)) {
      return;
    }
    const booking = changes.booking.currentValue;
    const statusArr = [];
    this.statusTypes.forEach((statusType) => {
      if (booking[statusType.refKey] && statusType.status[booking[statusType.refKey]]) {
        statusArr.push({
          denoter: statusType.status[booking[statusType.refKey]].denoter,
          styleClass: statusType.status[booking[statusType.refKey]].color,
          orderClass: this.getPrecedenceClass(statusArr.length + 1),
          descriptor: statusType.status[booking[statusType.refKey]].descriptor
        });
      }
    });
    this.bookingStatus = statusArr;
  }

  handleCardClick = () => {
    this.tooltipOpen = !this.tooltipOpen;
  }

  hideCardTooltip = () => {
    this.tooltipOpen = false;
  }

  getPrecedenceClass(precedence) {
    switch (precedence) {
      case 1: return 'first';
      case 2: return 'second';
      case 3: return 'third';
      case 4: return 'fourth';
      case 5: return 'fifth';
      case 6: return 'sixth';
    }
  }

}
